import { render } from "./TopicBadge.vue?vue&type=template&id=0c24e179&scoped=true"
import script from "./TopicBadge.vue?vue&type=script&lang=js"
export * from "./TopicBadge.vue?vue&type=script&lang=js"

import "./TopicBadge.vue?vue&type=style&index=0&id=0c24e179&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c24e179"]])

export default __exports__